import { EnergyProductPair } from '@eneco/dc-be/client/types.gen';
import { BundleProposal, ProductProposal } from '@sitecore/types/manual/be/ProductList';

import { getSitecoreBundle } from '../../../../utils/getSitecoreProduct';

const ENERGY_TYPE_ELECTRICITY = 'electric';
const ENERGY_TYPE_GAS = 'gas';

export const getSelectedProducts = (
  energyTypeSelection: string,
  enecoProductsList: ProductProposal[],
  enecoProductsBundlesList: BundleProposal[],
): {
  fixedProducts: EnergyProductPair[];
  variableProducts: EnergyProductPair[];
  dynamicProducts: EnergyProductPair[];
} => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const getProductName = (product: any) => product?.fields?.data?.productName?.value;
  const elecProducts = {
    fixed: enecoProductsList.filter(
      product =>
        product.fields.data.productTypeOption.value === 'fixed' &&
        product.fields.data.enecoProductsEnergyTypesOption.value === 'Electricity',
    ),
    variable: enecoProductsList.filter(
      product =>
        product.fields.data.productTypeOption.value === 'variable' &&
        product.fields.data.enecoProductsEnergyTypesOption.value === 'Electricity',
    ),
    dynamic: enecoProductsList.filter(
      product =>
        product.fields.data.productTypeOption.value === 'dynamic' &&
        product.fields.data.enecoProductsEnergyTypesOption.value === 'Electricity',
    ),
  };
  const gasProducts = {
    fixed: enecoProductsList.filter(
      product =>
        product.fields.data.productTypeOption.value === 'fixed' &&
        product.fields.data.enecoProductsEnergyTypesOption.value === 'Gas',
    ),
    variable: enecoProductsList.filter(
      product =>
        product.fields.data.productTypeOption.value === 'variable' &&
        product.fields.data.enecoProductsEnergyTypesOption.value === 'Gas',
    ),
    dynamic: enecoProductsList.filter(
      product =>
        product.fields.data.productTypeOption.value === 'dynamic' &&
        product.fields.data.enecoProductsEnergyTypesOption.value === 'Gas',
    ),
  };
  const fixedProducts: EnergyProductPair[] = [];
  const variableProducts: EnergyProductPair[] = [];
  const dynamicProducts: EnergyProductPair[] = [];

  if (energyTypeSelection == 'Both') {
    for (const bundle of enecoProductsBundlesList) {
      const scBundle = getSitecoreBundle({
        technicalProductNameElec: bundle.fields.data.enecoProductsElectricityList.value,
        technicalProductNameGas: bundle.fields.data.enecoProductsGasList.value,
        enecoProductsBundlesList: enecoProductsBundlesList,
        enecoProductsList: enecoProductsList,
      });

      if (scBundle.elecProduct && scBundle.gasProduct) {
        if (scBundle.elecProduct.fields.data.productTypeOption.value === 'fixed') {
          fixedProducts.push({
            [ENERGY_TYPE_ELECTRICITY]: scBundle.elecProduct.name,
            [ENERGY_TYPE_GAS]: scBundle.gasProduct.name,
          });
        } else if (scBundle.elecProduct.fields.data.productTypeOption.value === 'variable') {
          variableProducts.push({
            [ENERGY_TYPE_ELECTRICITY]: scBundle.elecProduct.name,
            [ENERGY_TYPE_GAS]: scBundle.gasProduct.name,
          });
        } else if (scBundle.elecProduct.fields.data.productTypeOption.value === 'dynamic') {
          dynamicProducts.push({
            [ENERGY_TYPE_ELECTRICITY]: scBundle.elecProduct.name,
            [ENERGY_TYPE_GAS]: scBundle.gasProduct.name,
          });
        }
      }
    }
  } else {
    const products = energyTypeSelection === 'Electricity' ? elecProducts : gasProducts;
    const energyKey = energyTypeSelection === 'Electricity' ? ENERGY_TYPE_ELECTRICITY : ENERGY_TYPE_GAS;
    products.fixed.forEach(product => {
      const name = getProductName(product);
      if (name) fixedProducts.push({ [energyKey]: name });
    });
    products.variable.forEach(product => {
      const name = getProductName(product);
      if (name) variableProducts.push({ [energyKey]: name });
    });
    products.dynamic.forEach(product => {
      const name = getProductName(product);
      if (name) dynamicProducts.push({ [energyKey]: name });
    });
  }
  return { fixedProducts, variableProducts, dynamicProducts };
};
